import { render, staticRenderFns } from "./StorkProductList.vue?vue&type=template&id=cc7c151e&scoped=true&"
import script from "./StorkProductList.vue?vue&type=script&lang=js&"
export * from "./StorkProductList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc7c151e",
  null
  
)

export default component.exports